import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { ICategory, translateCategory } from '@src/types/category.types'
import categoriesApi from '@src/api/categories'
import useUser from '@src/composables/user'

export const useCategoriesStore = defineStore('categories', () => {
  const categories = ref<ICategory[]>([])
  const loading = ref(false)
  const error = ref(false)
  const categoriesLoaded = ref(false)

  const { language } = useUser()

  const categoriesTranslated = computed(() => {
    const currentLanguage = language.value
    return categories.value.map((category) => ({
      ...category,
      name: translateCategory(category, currentLanguage)
    }))
  })

  async function loadCategories(force = false) {
    if (!force && categoriesLoaded.value) {
      return
    }
    loading.value = true
    error.value = false
    try {
      const { data: { items: fetchedCategories } } = await categoriesApi.throttled.getCategories()
      categories.value = fetchedCategories
      categoriesLoaded.value = true
    } catch {
      error.value = true
    } finally {
      loading.value = false
    }
  }

  return {
    categories,
    loading,
    error,
    categoriesTranslated,
    categoriesLoaded,
    loadCategories
  }
})
